function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import window from 'global/window';
import * as Dom from '@emav-util/dom.js';
import * as DomData from '@emav-util/dom-data';
import * as Fn from '@emav-util/fn.js';
import * as Guid from '@emav-util/guid.js';
import log from '@emav-util/log.js';
import evented from './mixins/evented';
import stateful from './mixins/stateful';
import mergeOptions from '@emav-util/merge-options.js';
var Component = function () {
    function Component(player, options, ready) {
        _classCallCheck(this, Component);
        if (!player && this.play) {
            this.player_ = player = this;
        } else {
            this.player_ = player;
        }
        this.parentComponent_ = null;
        this.options_ = mergeOptions({}, this.options_);
        options = this.options_ = mergeOptions(this.options_, options);
        this.id_ = options.id || options.el && options.el.id;
        if (!this.id_) {
            var id = player && player.id && player.id() || 'no_player';
            this.id_ = ''.concat(id, '_component_').concat(Guid.newGUID());
        }
        this.name_ = options.name || null;
        if (options.el) {
            this.el_ = options.el;
        } else if (options.createEl !== false) {
            this.el_ = this.createEl();
        }
        if (options.evented !== false) {
            evented(this, { eventBusKey: this.el_ ? 'el_' : null });
        }
        stateful(this, this.constructor.defaultState);
        this.ready(ready);
        if (options.reportTouchActivity !== false) {
            this.enableTouchActivity();
        }
    }
    _createClass(Component, [
        {
            key: 'dispose',
            value: function dispose() {
                this.player_ = null;
            }
        },
        {
            key: 'player',
            value: function player() {
                return this.player_;
            }
        },
        {
            key: 'options',
            value: function options(obj) {
                log.warn('this.options() has been deprecated and will be moved to the constructor in 6.0');
                if (!obj) {
                    return this.options_;
                }
                this.options_ = mergeOptions(this.options_, obj);
                return this.options_;
            }
        },
        {
            key: 'contentEl',
            value: function contentEl() {
                return this.contentEl_ || this.el_;
            }
        },
        {
            key: 'localize',
            value: function localize(string, tokens) {
                var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : string;
                var code = this.player_.language && this.player_.language();
                var languages = this.player_.languages && this.player_.languages();
                var language = languages && languages[code];
                var primaryCode = code && code.split('-')[0];
                var primaryLang = languages && languages[primaryCode];
                var localizedString = defaultValue;
                if (language && language[string]) {
                    localizedString = language[string];
                } else if (primaryLang && primaryLang[string]) {
                    localizedString = primaryLang[string];
                }
                if (tokens) {
                    localizedString = localizedString.replace(/\{(\d+)\}/g, function (match, index) {
                        var value = tokens[index - 1];
                        var ret = value;
                        if (typeof value === 'undefined') {
                            ret = match;
                        }
                        return ret;
                    });
                }
                return localizedString;
            }
        },
        {
            key: 'id',
            value: function id() {
                return this.id_;
            }
        },
        {
            key: 'name',
            value: function name() {
                return this.name_;
            }
        },
        {
            key: 'ready',
            value: function ready(fn) {
                var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (!fn) {
                    return;
                }
                if (!this.isReady_) {
                    this.readyQueue_ = this.readyQueue_ || [];
                    this.readyQueue_.push(fn);
                    return;
                }
                if (sync) {
                    fn.call(this);
                } else {
                    this.setTimeout(fn, 1);
                }
            }
        },
        {
            key: 'triggerReady',
            value: function triggerReady() {
                this.isReady_ = true;
                this.setTimeout(function () {
                    var readyQueue = this.readyQueue_;
                    this.readyQueue_ = [];
                    if (readyQueue && readyQueue.length > 0) {
                        readyQueue.forEach(function (fn) {
                            fn.call(this);
                        }, this);
                    }
                    console.log('#########################\t triggerReady');
                    this.trigger('ready');
                }, 1);
            }
        },
        {
            key: '$',
            value: function $(selector, context) {
                return Dom.$(selector, context || this.contentEl());
            }
        },
        {
            key: '$$',
            value: function $$(selector, context) {
                return Dom.$$(selector, context || this.contentEl());
            }
        },
        {
            key: 'hasClass',
            value: function hasClass(classToCheck) {
                return Dom.hasClass(this.el_, classToCheck);
            }
        },
        {
            key: 'addClass',
            value: function addClass(classToAdd) {
                Dom.addClass(this.el_, classToAdd);
            }
        },
        {
            key: 'removeClass',
            value: function removeClass(classToRemove) {
                Dom.removeClass(this.el_, classToRemove);
            }
        },
        {
            key: 'toggleClass',
            value: function toggleClass(classToToggle, predicate) {
                Dom.toggleClass(this.el_, classToToggle, predicate);
            }
        },
        {
            key: 'setTimeout',
            value: function setTimeout(fn, timeout) {
                var _this = this;
                var timeoutId, disposeFn;
                fn = Fn.bind(this, fn);
                timeoutId = window.setTimeout(function () {
                    _this.off('dispose', disposeFn);
                    fn();
                }, timeout);
                disposeFn = function disposeFn() {
                    return _this.clearTimeout(timeoutId);
                };
                disposeFn.guid = 'emav-timeout-'.concat(timeoutId);
                this.on('dispose', disposeFn);
                return timeoutId;
            }
        },
        {
            key: 'clearTimeout',
            value: function clearTimeout(timeoutId) {
                window.clearTimeout(timeoutId);
                var disposeFn = function disposeFn() {
                };
                disposeFn.guid = 'emav-timeout-'.concat(timeoutId);
                this.off('dispose', disposeFn);
                return timeoutId;
            }
        },
        {
            key: 'setInterval',
            value: function setInterval(fn, interval) {
                var _this2 = this;
                fn = Fn.bind(this, fn);
                var intervalId = window.setInterval(fn, interval);
                var disposeFn = function disposeFn() {
                    return _this2.clearInterval(intervalId);
                };
                disposeFn.guid = 'emav-interval-'.concat(intervalId);
                this.on('dispose', disposeFn);
                return intervalId;
            }
        },
        {
            key: 'clearInterval',
            value: function clearInterval(intervalId) {
                window.clearInterval(intervalId);
                var disposeFn = function disposeFn() {
                };
                disposeFn.guid = 'emav-interval-'.concat(intervalId);
                this.off('dispose', disposeFn);
                return intervalId;
            }
        },
        {
            key: 'requestAnimationFrame',
            value: function requestAnimationFrame(fn) {
                var _this3 = this;
                var id, disposeFn;
                if (this.supportsRaf_) {
                    fn = Fn.bind(this, fn);
                    id = window.requestAnimationFrame(function () {
                        _this3.off('dispose', disposeFn);
                        fn();
                    });
                    disposeFn = function disposeFn() {
                        return _this3.cancelAnimationFrame(id);
                    };
                    disposeFn.guid = 'emav-raf-'.concat(id);
                    this.on('dispose', disposeFn);
                    return id;
                }
                return this.setTimeout(fn, 1000 / 60);
            }
        },
        {
            key: 'cancelAnimationFrame',
            value: function cancelAnimationFrame(id) {
                if (this.supportsRaf_) {
                    window.cancelAnimationFrame(id);
                    var disposeFn = function disposeFn() {
                    };
                    disposeFn.guid = 'emav-raf-'.concat(id);
                    this.off('dispose', disposeFn);
                    return id;
                }
                return this.clearTimeout(id);
            }
        }
    ]);
    return Component;
}();
Component.prototype.supportsRaf_ = typeof window.requestAnimationFrame === 'function' && typeof window.cancelAnimationFrame === 'function';
export default Component;